/**
 * Theme typography settings for the application.
 * This includes font families, weights, and styles for various text elements.
 */
const typography = {
  // Global font stack
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,

  // Heading styles
  h1: {
    fontSize: '2.5rem',    // 40px
    lineHeight: 1.2,
    fontWeight: 300,
  },
  h2: {
    fontSize: '2rem',      // 32px
    lineHeight: 1.3,
    fontWeight: 300,
  },
  h3: {
    fontSize: '1.75rem',   // 28px
    lineHeight: 1.3,
    fontWeight: 400,
  },
  h4: {
    fontSize: '1.5rem',    // 24px
    lineHeight: 1.4,
    fontWeight: 400,
  },
  h5: {
    fontSize: '1.25rem',   // 20px
    lineHeight: 1.5,
    fontWeight: 400,
  },
  h6: {
    fontSize: '1rem',      // 16px
    lineHeight: 1.6,
    fontWeight: 400,
  },

  // Subtitle styles
  subtitle1: {
    fontSize: '1rem',      // 16px
    lineHeight: 1.75,
    fontWeight: 400,
  },
  subtitle2: {
    fontSize: '0.875rem',  // 14px
    lineHeight: 1.57,
    fontWeight: 400,
  },

  // Body text
  body1: {
    fontSize: '1rem',      // 16px
    lineHeight: 1.5,
    fontWeight: 400,
  },
  body2: {
    fontSize: '0.875rem',  // 14px
    lineHeight: 1.43,
    fontWeight: 400,
  },

  // Button text
  button: {
    fontSize: '0.875rem',  // 14px
    lineHeight: 1.75,
    fontWeight: 500,
    textTransform: 'uppercase',
  },

  // Caption and overline
  caption: {
    fontSize: '0.75rem',   // 12px
    lineHeight: 1.66,
    fontWeight: 400,
  },
  overline: {
    fontSize: '0.75rem',   // 12px
    lineHeight: 2.66,
    fontWeight: 400,
    textTransform: 'uppercase',
  },
};

export default typography;